__turbopack_context__.v({
  "anchor": "Anchor-module-scss-module__FqFMva__anchor",
});
